module.exports = __webpack_public_path__ + "img/i6.73e43eb4.png";